import clsx from "clsx";
import React, { useState, useMemo, useEffect } from "react";
import DialogRsOL from "./DialogRsOL";
import {
  useSearchDatatables,
  // useFetch
} from "App/hooks";
import { defaultDateDisplay } from "App/utils/helpers";
import { STYLE_DEFAULT_TAB_BED } from "App/constants/theme";
import { PencilIcon, SelectIcon, TrashIcon } from "App/Assets";
import ModalKlsRsOL from "./ModalKlsRsOL";
import ModalKetersediaanRsOL from "./ModalKetersediaanRsOL";
// import { LIST_URL_MASTER } from "utils/masters";
// import { TYPE_INSTANCE2 } from "App/constants";
import { ModalFormKelas } from "./ModalFormKelas";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import {
  defaultToastError,
  // defaultToastSuccess
} from "App/utils/helpers";

import {
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Toolbar,
  makeStyles,
  Typography
} from "@material-ui/core";

import {
  DatatablesFooter,
  IconButtonDatatable,
  SearchInput,
  // TableToolbar,
  MasterButton,
  ModalDefaultError,
  ModalDeleteConfirm,
  TableHeader,
} from "App/Component/ui";

import {
  deleteSirsOnlineById,
  getAllSirsOnline,
  headCells,
  RESET_STATE_SIRS_ONLINE,
  convertToValidListRsOL,
  getListReferensiSirsOL,
  RESET_ROW_STATE_KETERSEDIAAN_SIRS_ONLINE,
  postToServerSirsOnline,
  getListKetersediaanSirsOL,
  // getListRuangSirsOnline,
  getListRuangFromApplicare
} from "App/Component/layout/MasterData/Bed/ui/TabKelasKamarSirsOnline/helpers";

const useStyles = STYLE_DEFAULT_TAB_BED;

let PageSize = 10;

export default function TabKelasKamar() {
  const classes = useStyles();

  /* State */
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("name");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PageSize);

  const [openRsOL, setOpenRsOL] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalDefaultError, setShowModalDefaultError] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [showModalKetersediaanRsOL, setShowModalKetersediaanRsOL] = useState(false);
  const [showModalRuangKlsRsOL, setShowModalRuangKlsRsOL] = useState(false);

  const [run, setRun] = useState(false);
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const [dataReferensi, setDataReferensi] = useState([]);

  /* for ModalKlsRsOL */
  const [stateUpdate, setStateUpdate] = useState(false);
  const [rowsKlsSirsOL, setRowsKlsSirsOL] = useState([]);
  const [klsRsOL, setKlsRsOL] = useState([]);

  const [formData, setFormData] = useState(RESET_STATE_SIRS_ONLINE);
  const [formDataKetersediaan, setFormDataKetersediaan] = useState(RESET_ROW_STATE_KETERSEDIAAN_SIRS_ONLINE);
  /* End State */

  const { data, length } = useSearchDatatables(rows, q, ["name"]);

  const useToolbarStyles = makeStyles((theme) => ({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      display: "flex",
      justifyContent: "space-between",
    },
    title: {
      fontSize: "14px",
      textTransform: "uppercase",
      fontWeight: "600",
    },
    wrapper: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginRight: "5px",
    },
  }));

  const classToolbar = useToolbarStyles();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const fetchKlsRsOL = async () => {
    const result = await getListRuangFromApplicare();
    if (result) {
      setKlsRsOL(result || []);
    }
  };

  const handleClickKetersediaanRsOL = (row) => {
    setShowModalKetersediaanRsOL(!showModalKetersediaanRsOL);
    setFormDataKetersediaan({
      id: row?.id,
      name: row?.name,
      remark: row?.remark,
      kodebridgingsirs: row?.kodebridgingsirs,
      id_ruang_sirsonline: row?.id_ruang_sirsonline,
    });
  };

  const handleOpenRsOL = async (pages, limit) => {
    setOpenRsOL(true);

    const response = await getListReferensiSirsOL(pages, limit);
    if (response.state) {
      setDataReferensi(response.data);
    } else {
      setDataReferensi([]);
    }
  };

  const handleClickSelectRowRsOL = async (row) => {
    setFormDataKetersediaan({
      id: row?.id,
      name: row?.name,
      remark: row?.remark,
      kodebridgingsirs: row?.kodebridgingsirs,
      id_ruang_aplicares: row?.id_ruang_aplicares,
    });
    setStateUpdate(false);

    const arr = convertToValidListRsOL(klsRsOL, row?.id_ruang_aplicares);

    setShowModalRuangKlsRsOL(!showModalRuangKlsRsOL);
    setRowsKlsSirsOL(arr);
  };

  const handleClickAddKlsSirsOL = async (row) => {
    try {
      const check = rowsKlsSirsOL.filter((e) => e.id === row.id);
      if (check.length > 0) {
        defaultToastError("Data sudah ada");
        return false;
      };

      const rowsRsOl = rowsKlsSirsOL;
      const newRowsRsOl = [row, ...rowsRsOl];
      const _temp = [];
      newRowsRsOl.map((item) => _temp.push(item.id));

      const idHapus = null;

      const responsePostServer = await postToServerSirsOnline(_temp, formDataKetersediaan, stateUpdate, idHapus, "buat");
      if (responsePostServer.state) {
        const listUpdate = await getListKetersediaanSirsOL(formDataKetersediaan.id)

        if (listUpdate.state) {
          setRowsKlsSirsOL(listUpdate.data);
        } else {
          defaultToastError(listUpdate.message);
        }

        setRun(!run);
        fetchKlsRsOL();
      } else {
        defaultToastError("Error");
      }
    } catch (error) {
      defaultToastError("Terjadi kesalahan saat menambahkan data");
    }
  };

  const handleClickDeleteKlsSirsOl = async (row) => {
    try {
      const newRowsRsOlDel = rowsKlsSirsOL.filter((e) => e.id !== row.id);

      const _temp = [];
      newRowsRsOlDel.map((item) => _temp.push(item.id));

      const idHapus = row.id;

      const responsePostServer = await postToServerSirsOnline(_temp, formDataKetersediaan, stateUpdate, idHapus, "hapus");
      if (responsePostServer.state) {
        const listUpdate = await getListKetersediaanSirsOL(formDataKetersediaan.id)

        if (listUpdate.state) {
          setRowsKlsSirsOL(listUpdate.data);
        } else {
          defaultToastError(listUpdate.message);
        }

        setRun(!run);
        fetchKlsRsOL();
      } else {
        defaultToastError("Error");
      }
    } catch (error) {
      defaultToastError("Terjadi kesalahan saat menambahkan data");
    }
  };

  useEffect(() => {
    (async () => {
      const res = await getAllSirsOnline();
      if (res) {
        setRows(res);
      } else {
        setShowModalDefaultError(true);
      }

      fetchKlsRsOL();
    })();
  }, [run]);

  useMemo(() => {
    const firstPageIndex = (page - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return data.slice(firstPageIndex, lastPageIndex);
  }, [page, data]);

  return (
    <div>
      {openRsOL && (
        <DialogRsOL
          setShowModal={() => setOpenRsOL(false)}
          dataReferensi={dataReferensi}
        />
      )}

      {showModalRuangKlsRsOL && (
        <ModalKlsRsOL
          setShowModal={() => setShowModalRuangKlsRsOL(false)}
          rowsKlsSirsOL={rowsKlsSirsOL}
          rows={klsRsOL}
          stateUpdate={stateUpdate}
          setStateUpdate={setStateUpdate}
          handleClickAddKlsSirsOL={handleClickAddKlsSirsOL}
          handleClickDeleteKlsSirsOl={handleClickDeleteKlsSirsOl}
        />
      )}

      {showModalKetersediaanRsOL && (
        <ModalKetersediaanRsOL
          setShowModal={() => setShowModalKetersediaanRsOL(false)}
          id={formDataKetersediaan.id}
        />
      )}

      {showModal && (
        <ModalFormKelas
          run={() => setRun(!run)}
          setShowModal={() => setShowModal(false)}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {showModalDefaultError && (
        <ModalDefaultError
          setShowModalDefaultError={() => setShowModalDefaultError(true)}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() =>
            deleteSirsOnlineById(
              formData.id,
              () => setRun(!run),
              setShowModalDeleteConfirm,
              setFormData
            )
          }
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <Paper>
        <Toolbar className={clsx(classToolbar.root)}>
          <div className={classToolbar.wrapper}>
            <Typography
              className={classToolbar.title}
              variant="h6"
              id="tableTitle"
              component="div"
            >
              Daftar kls rs online
            </Typography>
            <MasterButton
              name="KLS RS OL"
              color="indigo"
              onClick={() => handleOpenRsOL()}
            />
          </div>
          <div className={classToolbar.wrapper}>
            <SearchInput withIcon={true} onchange={(e) => setQ(e.target.value)} />
            <MasterButton
              type={"submit"}
              color='green'
              name='Tambah'
              size='md'
              onClick={() => {
                setFormData(RESET_STATE_SIRS_ONLINE);
                setShowModal(!showModal);
              }}
            />
            {/* <MasterButton
              type={"submit"}
              color='warning'
              name='Export'
              size='md'
            /> */}
          </div>
        </Toolbar>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby='tableTitle'
            size={"medium"}
            aria-label='enhanced table'>
            <TableHeader
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={length}
              headCells={headCells}
            />
            <TableBody>
              {stableSort(data, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={index}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "transparent" : "#fff",
                      }}>
                      <TableCell
                        component='th'
                        scope='row'
                        padding='none'
                        align='center'>
                        {index + 1}
                      </TableCell>

                      <TableCell
                        component='th'
                        scope='row'
                        padding='none'
                        align='center'>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                          }}>
                          <IconButtonDatatable
                            onClick={() => handleClickSelectRowRsOL(row)}
                          >
                            <SelectIcon
                              width={"16"}
                              height={"16"}
                              fill={"#fff"}
                            />
                          </IconButtonDatatable>
                          <IconButtonDatatable
                            onClick={() => {
                              setFormData({
                                id: row?.id,
                                name: row?.name,
                                remark: row?.remark,
                                kodebridgingsirs: row?.kodebridgingsirs,
                              });

                              setShowModal(true);
                            }}>
                            <PencilIcon />
                          </IconButtonDatatable>
                          <IconButtonDatatable
                            onClick={() => {
                              setFormData({
                                ...formData,
                                id: row?.id,
                              });
                              setShowModalDeleteConfirm(
                                !showModalDeleteConfirm
                              );
                            }}>
                            <TrashIcon />
                          </IconButtonDatatable>
                        </div>
                      </TableCell>
                      <TableCell align='left'>{row?.id}</TableCell>
                      <TableCell align='left'>{row?.kodebridgingsirs}</TableCell>
                      <TableCell align='left'>{row?.name}</TableCell>
                      <TableCell align="left">
                        <MasterButton
                          type="button"
                          color="warning"
                          name="UPDATE RS OL"
                          onClick={() => handleClickKetersediaanRsOL(row)}
                        />
                      </TableCell>
                      <TableCell align='left'>{row?.remark}</TableCell>
                      <TableCell align='left'>{defaultDateDisplay(row?.createdAt)}</TableCell>
                      <TableCell align='left'>{row?.createdName}</TableCell>
                      <TableCell align='left'>{defaultDateDisplay(row?.updatedAt)}</TableCell>
                      <TableCell align='left'>{row?.updatedName}</TableCell>
                    </TableRow>
                  );
                })}
              {rows.length === 0 && (
                <TableRow>
                  <TableCell align='center' colSpan={headCells.length}>
                    Tidak ada data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <DatatablesFooter
          page={page}
          length={data.length}
          rowsPerPage={rowsPerPage}
          selectRows={[10, 20]}
          onPageChange={(page) => setPage(page - 1)}
          onSelectChange={(e) => setRowsPerPage(e.target.value)}
        />
      </Paper>
    </div>
  );
}
